import { apiCall } from './gqlClient';
const GETTIMEZONES_QUERY = "\n  query getTimezones {\n    getTimezones\n    {\n      id\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getTimezonesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETTIMEZONES_QUERY,
    variables: {},
    fragments
  });
};
const GETPROVIDERTIMEZONE_QUERY = "\n  query getProviderTimezone($id: Int) {\n    getProviderTimezone(id: $id)\n  }";
export const getProviderTimezoneApiCall = async _ref => {
  let {
    id
  } = _ref;
  return apiCall({
    query: GETPROVIDERTIMEZONE_QUERY,
    variables: {
      id
    }
  });
};
const GETUSERTIMEZONE_QUERY = "\n  query getUserTimezone($id: Int) {\n    getUserTimezone(id: $id)\n  }";
export const getUserTimezoneApiCall = async _ref2 => {
  let {
    id
  } = _ref2;
  return apiCall({
    query: GETUSERTIMEZONE_QUERY,
    variables: {
      id
    }
  });
};
const SAVEUSERTIMEZONE_QUERY = "\n  mutation saveUserTimeZone($timezone: String!) {\n    saveUserTimeZone(timezone: $timezone)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveUserTimeZoneApiCall = async function (_ref3) {
  let {
    timezone
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEUSERTIMEZONE_QUERY,
    variables: {
      timezone
    },
    fragments
  });
};
const SAVEPROVIDERTIMEZONE_QUERY = "\n  mutation saveProviderTimeZone($timezone: String!) {\n    saveProviderTimeZone(timezone: $timezone)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveProviderTimeZoneApiCall = async function (_ref4) {
  let {
    timezone
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEPROVIDERTIMEZONE_QUERY,
    variables: {
      timezone
    },
    fragments
  });
};